import type { HttpResponse } from './http-client';
import type { HandleResponse } from './types';

/**
 * Проверяет, попадает ли HTTP-статус в успешный диапазон 2xx.
 *
 * @param status Код статуса ответа.
 * @returns true для кодов 200-299, иначе false.
 */
const isSuccessfulStatus = (status: number) => status >= 200 && status < 300;

/**
 * Собирает итоговую структуру ответа, которую использует слой API приложения.
 *
 * @param response Сырой нормализованный HTTP-ответ.
 * @returns Объект с исходным ответом, флагом успешности и полезной нагрузкой.
 */
export const handleResponse = <T>(response: HttpResponse<T>): HandleResponse<T> => ({
	response,
	isOkStatus: isSuccessfulStatus(response.status),
	data: response.data,
});
